<template>
  <div id="app"
       class="helper"
       ref="backgroundHolder">
    <index-link v-if="config.debugMode" />
    <router-view v-show="wordingsReady"
                 @loading="handleLoading"
                 @loaded="handleLoaded"
                 @loadingWordings="handleLoadingWordings"
                 @loadedWordings="handleLoadedWordings"
                 @failedWordings="handleFailedWordings"
                 @autoSubmit="autoSubmit = true"
                 @noAutoSubmit="autoSubmit = false"
                 :autoSubmit="autoSubmit"
                 @regPassword="password => regPassword = password"
                 :regPassword="regPassword" />
    <div v-show="!wordingsReady"
         class="content">
      <div class="container">
        <div class="loading-spinner">
          <div class="loading-spinner-image"></div>
        </div>
      </div>
    </div>
    <div ref="spinner"
         class="loading-spinner">
      <div class="loading-spinner-image"></div>
    </div>
    <reg-flash-message />
  </div>
</template>

<script>
import config from 'config';
import indexLink from './layout/DebugIndexLink';
import instanceConfig from './utils/instanceConfig';
import $ from 'jquery';
import regFlashMessage from './layout/FlashMessage'

export const store = {
  forms: {
    registration: {},
  },
};

export default {
  name: 'app',
  components: { indexLink, regFlashMessage },
  data() {
    return {
      config,
      wordingsReady: true,
      autoSubmit: false,
      regPassword: '',
    };
  },
  mounted() {
    instanceConfig.setCurrentLang(window.localStorage.getItem('lang'));
  },
  watch: {
    $route() {
      this.wordingsReady = true;
      this.scrollTop();
      this.flash().destroyAll();
    },
  },
  methods: {
    scrollTop() {
      $('html, body').animate({ scrollTop: 0 }, 0);
    },
    handleLoading() {
      this.$refs.spinner.style.display = 'block';
    },
    handleLoaded() {
      this.$refs.spinner.style.display = 'none';
    },
    handleLoadingWordings() {
      this.wordingsReady = false;
    },
    handleLoadedWordings() {
      this.wordingsReady = true;
    },
    handleFailedWordings() {
      this.$router.push({ name: 'error' });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue